// Action creators
import {
    ADD_CASE_FILE,
    FETCH_CASE_FAILURE,
    FETCH_CASE_START,
    FETCH_CASE_SUCCESS,
    REMOVE_CASE_FILE,
    MARK_CASE_SLIDE_READ
} from "../redux_constants/case.constant";
import {get} from "../helper/request";

export const fetchCaseStart = () => ({
    type: FETCH_CASE_START,
});

export const fetchCaseSuccess = (data, case_refresh) => ({
    type: FETCH_CASE_SUCCESS,
    payload: data,
    case_refresh: case_refresh
});

export const fetchCaseFailure = (error) => ({
    type: FETCH_CASE_FAILURE,
    payload: error,
});

export const addCaseFile = (payload) => ({
    type: ADD_CASE_FILE,
    payload: payload
})

export const removeCaseFile = (fileId) => ({
    type: REMOVE_CASE_FILE,
    fileId: fileId
})

export const markCaseSlideRead = (slideId, unread) => ({
    type: MARK_CASE_SLIDE_READ,
    slideId: slideId,
    unread: unread
})


// Async action using thunk
export const fetchCase = (case_id, case_refresh) => (dispatch) => {
    dispatch(fetchCaseStart());
    get(`/api/case/${case_id}/`)
        .then((data) => dispatch(fetchCaseSuccess(data, case_refresh)))
        .catch((error) => dispatch(fetchCaseFailure(error)));
};